import { render, staticRenderFns } from "./MultiPageA4.vue?vue&type=template&id=71681401&scoped=true"
import script from "./MultiPageA4.vue?vue&type=script&lang=js"
export * from "./MultiPageA4.vue?vue&type=script&lang=js"
import style0 from "./MultiPageA4.vue?vue&type=style&index=0&id=71681401&prod&lang=scss&scoped=true"
import style1 from "./MultiPageA4.vue?vue&type=style&index=1&id=71681401&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71681401",
  null
  
)

export default component.exports